import { ROLES } from "./constants";

export const ORDER_TYPES = {
  ORIGINAL: "original",
  FAKE: "fake",
};

export const ROLE_ORDER_TYPES = {
  [ROLES.ADMIN]: [ORDER_TYPES.ORIGINAL, ORDER_TYPES.FAKE],
  [ROLES.SUPER_ADMIN]: [ORDER_TYPES.ORIGINAL, ORDER_TYPES.FAKE],
  [ROLES.STORES]: [ORDER_TYPES.ORIGINAL, ORDER_TYPES.FAKE],
};
